module.exports = __webpack_public_path__ + "static/media/icon_coupon_a.77cdcfed.svg";